import { forwardRef, useCallback } from "react";

import { Box, IconButton, Stack } from "@mui/material";
import { XCloseIcon } from "components";
import { base } from "configs/colors";
import { shadows } from "configs/shadows";
import { CustomContentProps, SnackbarContent, useSnackbar } from "notistack";

export const SnackbarDefault = forwardRef<HTMLDivElement, CustomContentProps>(
  ({ id, ...props }, ref) => {
    const { closeSnackbar } = useSnackbar();

    const handleDismiss = useCallback(() => {
      closeSnackbar(id);
    }, [id, closeSnackbar]);

    return (
      <SnackbarContent
        ref={ref}
        style={{
          background: base.White,
          boxShadow: shadows.sm,
          borderRadius: "8px",
          padding: "12px 10px",
          width: 300,
        }}
      >
        <Stack
          width="100%"
          direction="row"
          justifyContent="space-between"
          gap={2}
        >
          <Box>{props.message}</Box>
          <Box flexBasis="36px">
            <IconButton onClick={handleDismiss}>
              <XCloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </Stack>
      </SnackbarContent>
    );
  }
);
